import React from 'react';
import Establishment from './Establishment';
import SearchForm from './SearchForm';
import Menu from './Menu';

const Topbar = () => (
    <nav className="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
        <div className="container-fluid">
            <Establishment />
            <SearchForm />
            <Menu />
        </div>
    </nav>
);

export default Topbar;


// WEBPACK FOOTER //
// ./src/components/Layout/Topbar/index.js